import { render, staticRenderFns } from "./CollaboratorWithUser.vue?vue&type=template&id=40d20f43&scoped=true&"
import script from "./CollaboratorWithUser.vue?vue&type=script&lang=js&"
export * from "./CollaboratorWithUser.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorWithUser.vue?vue&type=style&index=0&id=40d20f43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d20f43",
  null
  
)

export default component.exports